import Backbone from 'backbone';
import 'vendor/backbone.view';
import 'vendor/backbone.model';
window._ = require('underscore');
Backbone.View.prototype.childViews = {};
